import { ACCESS } from '@src/configs/permission'
import lazyLoading from '@src/components/widgets/LazyLoading'

import { TRouteConfig } from '../routeConfig'

const NotificationBroadcast = lazyLoading(() => import('@src/pages/notification-broadcast'))

const notificationRouter: TRouteConfig[] = [
  {
    path: '/notification-broadcast',
    Element: NotificationBroadcast,
    key: ACCESS.ADD_NOTIFICATION,
  },
]

export { notificationRouter }
